import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Message } from '../../components';
export const ApplyComplete = () => {
    const { t } = useTranslation();
    return (React.createElement(SContainer, null,
        React.createElement(SAlerArea, null,
            React.createElement(Message, { type: "success", title: t('申込完了'), variant: "outlined" },
                React.createElement("div", { style: { whiteSpace: 'pre-line' } }, t('確認後、IMORY運営事務局よりメールでご連絡致します。（通常５営業日以内）\n1週間以上経ってもメールが届かない場合はお手数ですが以下よりお問い合わせ下さい。\ninfo@imory-app.com'))))));
};
const SContainer = styled.div `
  background-color: #fff;
`;
const SAlerArea = styled.div `
  padding-top: 2px;
`;
